<template>
	<div class="aboutus-list-container">
		<!-- 列表页 -->
		<template v-if="showFlag">
			<!-- 页面头部 -->
			<div class="page-header">
				<div class="header-content">
					<div class="header-icon">
						<svg class="icon" viewBox="0 0 24 24">
							<path d="M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M21,9V7L15,1L13.5,2.5L16.17,5.17L10.58,10.76L9.17,9.35L7.76,10.76L12,15L21,9Z"/>
						</svg>
					</div>
					<div class="header-text">
						<h1 class="page-title">关于我们管理</h1>
						<p class="page-description">企业信息介绍与品牌形象展示管理</p>
					</div>
					<div class="header-actions">
						<el-button 
							v-if="isAuth('aboutus','新增')" 
							type="primary" 
							icon="el-icon-plus" 
							@click="addOrUpdateHandler()" 
							class="add-btn"
						>
							新增内容
						</el-button>
					</div>
				</div>
			</div>

			<!-- 搜索和筛选区域 -->
			<div class="filter-section">
				<el-card class="filter-card" shadow="never">
					<div class="filter-content">
						<el-form :inline="true" :model="searchForm" class="search-form">
							<div class="filter-row">
								<div class="filter-group">
									<label class="filter-label">标题</label>
									<div class="filter-input">
										<el-input 
											v-model="searchForm.title" 
											placeholder="请输入标题关键词" 
											clearable
											prefix-icon="el-icon-search"
											class="search-input"
										></el-input>
									</div>
								</div>
								
								<div class="filter-actions">
									<el-button 
										type="primary" 
										icon="el-icon-search" 
										@click="search()"
										class="search-btn"
									>
										查询
									</el-button>
									<el-button 
										icon="el-icon-refresh" 
										@click="resetSearch()"
										class="reset-btn"
									>
										重置
									</el-button>
								</div>
							</div>
						</el-form>
					</div>
				</el-card>
			</div>

			<!-- 操作栏 -->
			<div class="toolbar-section" v-if="dataListSelections.length > 0">
				<el-card class="toolbar-card" shadow="never">
					<div class="toolbar-content">
						<div class="selection-info">
							<i class="el-icon-info"></i>
							<span>已选择 <strong>{{ dataListSelections.length }}</strong> 项</span>
						</div>
						<div class="batch-actions">
							<el-button 
								v-if="isAuth('aboutus','删除')" 
								type="danger" 
								icon="el-icon-delete" 
								@click="deleteHandler()"
								:disabled="dataListSelections.length <= 0"
								class="batch-delete-btn"
							>
								批量删除
							</el-button>
						</div>
					</div>
				</el-card>
			</div>

			<!-- 数据表格 -->
			<div class="table-section">
				<el-card class="table-card" shadow="never">
					<el-table 
						class="data-table"
						:data="dataList"
						v-loading="dataListLoading"
						@selection-change="selectionChangeHandler"
						empty-text="暂无数据"
						element-loading-text="加载中..."
						element-loading-spinner="el-icon-loading"
					>
						<el-table-column 
							type="selection" 
							width="55" 
							align="center"
						></el-table-column>
						
						<el-table-column 
							label="序号" 
							type="index" 
							width="70" 
							align="center"
							:index="getTableIndex"
						></el-table-column>
						
						<el-table-column 
							prop="title"
							label="标题"
							min-width="200"
							show-overflow-tooltip
						>
							<template slot-scope="scope">
								<div class="title-content">
									<div class="title-icon">
										<svg viewBox="0 0 24 24">
											<path d="M5,4V7H10.5V19H13.5V7H19V4H5Z"/>
										</svg>
									</div>
									<div class="title-info">
										<div class="main-title">{{ scope.row.title }}</div>
										<div class="sub-title" v-if="scope.row.subtitle">{{ scope.row.subtitle }}</div>
									</div>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							label="展示图片" 
							width="280" 
							align="center"
						>
							<template slot-scope="scope">
								<div class="images-preview">
									<div class="image-item" v-if="scope.row.picture1">
										<img 
											v-if="scope.row.picture1.substring(0,4)=='http'" 
											:src="scope.row.picture1.split(',')[0]" 
											class="preview-img"
											@error="handleImageError"
										>
										<img 
											v-else 
											:src="$base.url+scope.row.picture1.split(',')[0]" 
											class="preview-img"
											@error="handleImageError"
										>
										<div class="image-label">图片1</div>
									</div>
									<div class="image-item" v-if="scope.row.picture2">
										<img 
											v-if="scope.row.picture2.substring(0,4)=='http'" 
											:src="scope.row.picture2.split(',')[0]" 
											class="preview-img"
											@error="handleImageError"
										>
										<img 
											v-else 
											:src="$base.url+scope.row.picture2.split(',')[0]" 
											class="preview-img"
											@error="handleImageError"
										>
										<div class="image-label">图片2</div>
									</div>
									<div class="image-item" v-if="scope.row.picture3">
										<img 
											v-if="scope.row.picture3.substring(0,4)=='http'" 
											:src="scope.row.picture3.split(',')[0]" 
											class="preview-img"
											@error="handleImageError"
										>
										<img 
											v-else 
											:src="$base.url+scope.row.picture3.split(',')[0]" 
											class="preview-img"
											@error="handleImageError"
										>
										<div class="image-label">图片3</div>
									</div>
									<div class="no-images" v-if="!scope.row.picture1 && !scope.row.picture2 && !scope.row.picture3">
										<i class="el-icon-picture"></i>
										<span>暂无图片</span>
									</div>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							prop="content"
							label="内容预览"
							min-width="300"
							show-overflow-tooltip
						>
							<template slot-scope="scope">
								<div class="content-preview">
									<div class="content-text" v-html="getContentPreview(scope.row.content)"></div>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							label="操作" 
							width="200" 
							align="center"
							fixed="right"
						>
							<template slot-scope="scope">
								<div class="action-buttons">
									<el-button 
										v-if="isAuth('aboutus','查看')" 
										type="info" 
										size="mini" 
										icon="el-icon-view"
										@click="addOrUpdateHandler(scope.row.id, 'info')"
										class="action-btn view-btn"
									>
										详情
									</el-button>
									<el-button 
										v-if="isAuth('aboutus','修改')" 
										type="primary" 
										size="mini" 
										icon="el-icon-edit"
										@click="addOrUpdateHandler(scope.row.id)"
										class="action-btn edit-btn"
									>
										编辑
									</el-button>
									<el-button 
										v-if="isAuth('aboutus','删除')" 
										type="danger" 
										size="mini" 
										icon="el-icon-delete"
										@click="deleteHandler(scope.row.id)"
										class="action-btn delete-btn"
									>
										删除
									</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</div>

			<!-- 分页 -->
			<div class="pagination-section">
				<el-pagination
					@size-change="sizeChangeHandle"
					@current-change="currentChangeHandle"
					:current-page="pageIndex"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalPage"
					class="data-pagination"
				></el-pagination>
			</div>
		</template>
		
		<!-- 添加/修改页面 -->
		<add-or-update v-if="addOrUpdateFlag" :parent="this" ref="addOrUpdate"></add-or-update>
	</div>
</template>

<script>
import axios from 'axios'
import AddOrUpdate from "./add-or-update";
export default {
  data() {
    return {
      searchForm: {
        key: ""
      },
      form:{},
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      sfshVisiable: false,
      shForm: {},
      chartVisiable: false,
      chartVisiable1: false,
      chartVisiable2: false,
      chartVisiable3: false,
      chartVisiable4: false,
      chartVisiable5: false,
      addOrUpdateFlag:false,
      layouts: ["total","prev","pager","next","sizes","jumper"],

    };
  },
  created() {
    this.init();
    this.getDataList();
    this.contentStyleChange()
  },
  mounted() {
  },
  filters: {
    htmlfilter: function (val) {
      return val.replace(/<[^>]*>/g).replace(/undefined/g,'');
    }
  },
  components: {
    AddOrUpdate,
  },
  methods: {

    contentStyleChange() {
      this.contentPageStyleChange()
    },
    // 分页
    contentPageStyleChange(){
      let arr = []

      // if(this.contents.pageTotal) arr.push('total')
      // if(this.contents.pageSizes) arr.push('sizes')
      // if(this.contents.pagePrevNext){
      //   arr.push('prev')
      //   if(this.contents.pagePager) arr.push('pager')
      //   arr.push('next')
      // }
      // if(this.contents.pageJumper) arr.push('jumper')
      // this.layouts = arr.join()
      // this.contents.pageEachNum = 10
    },








    // 获取表格索引
    getTableIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        title: ''
      };
      this.search();
    },

    // 处理图片加载错误
    handleImageError(event) {
      event.target.style.display = 'none';
    },

    // 获取内容预览
    getContentPreview(content) {
      if (!content) return '暂无内容';
      // 移除HTML标签，只保留文本
      const textContent = content.replace(/<[^>]*>/g, '');
      // 限制长度并添加省略号
      return textContent.length > 100 ? textContent.substring(0, 100) + '...' : textContent;
    },

    init () {
    },
    search() {
      this.pageIndex = 1;
      this.getDataList();
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        sort: 'id',
        order: 'desc',
      }
           if(this.searchForm.title!='' && this.searchForm.title!=undefined){
            params['title'] = '%' + this.searchForm.title + '%'
          }
      this.$http({
        url: "aboutus/page",
        method: "get",
        params: params
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.data.list;
          this.totalPage = data.data.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    // 添加/修改
    addOrUpdateHandler(id,type) {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      this.crossAddOrUpdateFlag = false;
      if(type!='info'){
        type = 'else';
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id,type);
      });
    },
    // 下载
    download(file){
      window.open(`${file}`)
    },
    // 删除
    deleteHandler(id) {
      var ids = id
        ? [Number(id)]
        : this.dataListSelections.map(item => {
            return Number(item.id);
          });
      this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "aboutus/delete",
          method: "post",
          data: ids
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.search();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },


  }

};
</script>
<style lang="scss" scoped>
.aboutus-list-container {
	background: #f8fafc;
	min-height: 100vh;
	padding: 24px;
}

// 页面头部
.page-header {
	margin-bottom: 24px;
	
	.header-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: white;
		padding: 24px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

		.header-icon {
			width: 56px;
			height: 56px;
			background: linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%);
			border-radius: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);

			.icon {
				width: 24px;
				height: 24px;
				fill: white;
			}
		}

		.header-text {
			flex: 1;
			margin-left: 16px;

			.page-title {
				font-size: 24px;
				font-weight: 600;
				color: #1e293b;
				margin: 0 0 4px 0;
			}

			.page-description {
				color: #64748b;
				font-size: 14px;
				margin: 0;
			}
		}

		.header-actions {
			.add-btn {
				padding: 12px 24px;
				font-weight: 500;
				border-radius: 8px;
			}
		}
	}
}

// 筛选区域
.filter-section {
	margin-bottom: 24px;

	.filter-card {
		border-radius: 8px;
		border: none;

		:deep(.el-card__body) {
			padding: 24px;
		}
	}

	.filter-content {
		.search-form {
			margin: 0;

			.filter-row {
				display: flex;
				align-items: flex-end;
				gap: 20px;
				flex-wrap: wrap;
			}

			.filter-group {
				display: flex;
				flex-direction: column;
				min-width: 200px;

				.filter-label {
					font-size: 14px;
					font-weight: 500;
					color: #374151;
					margin-bottom: 8px;
				}

				.filter-input {
					.search-input {
						width: 200px;
					}
				}
			}

			.filter-actions {
				display: flex;
				gap: 12px;
				margin-left: auto;

				.el-button {
					padding: 10px 20px;
					font-weight: 500;
					border-radius: 6px;
				}

				.search-btn {
					background: #7c3aed;
					border-color: #7c3aed;
				}

				.reset-btn {
					color: #6b7280;
					border-color: #d1d5db;

					&:hover {
						color: #374151;
						border-color: #9ca3af;
					}
				}
			}
		}
	}
}

// 工具栏
.toolbar-section {
	margin-bottom: 16px;

	.toolbar-card {
		border-radius: 8px;
		border: none;

		:deep(.el-card__body) {
			padding: 16px 24px;
		}
	}

	.toolbar-content {
		display: flex;
		align-items: center;
		justify-content: space-between;

		.selection-info {
			display: flex;
			align-items: center;
			gap: 8px;
			color: #7c3aed;
			font-size: 14px;

			i {
				font-size: 16px;
			}

			strong {
				color: #5b21b6;
			}
		}

		.batch-actions {
			.batch-delete-btn {
				padding: 8px 16px;
				font-size: 13px;
			}
		}
	}
}

// 表格区域
.table-section {
	margin-bottom: 24px;

	.table-card {
		border-radius: 8px;
		border: none;

		:deep(.el-card__body) {
			padding: 0;
		}
	}

	.data-table {
		:deep(.el-table__header) {
			th {
				background: #f8fafc;
				color: #374151;
				font-weight: 600;
				border-bottom: 1px solid #e5e7eb;
				padding: 16px 0;

				.cell {
					padding: 0 16px;
				}
			}
		}

		:deep(.el-table__body) {
			tr {
				&:hover {
					background: #f8fafc;
				}

				td {
					border-bottom: 1px solid #f1f5f9;
					padding: 16px 0;

					.cell {
						padding: 0 16px;
					}
				}
			}
		}

		// 标题内容
		.title-content {
			display: flex;
			align-items: flex-start;
			gap: 12px;

			.title-icon {
				width: 20px;
				height: 20px;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;
				margin-top: 2px;

				svg {
					width: 16px;
					height: 16px;
					fill: #7c3aed;
				}
			}

			.title-info {
				flex: 1;

				.main-title {
					font-weight: 600;
					font-size: 14px;
					color: #1e293b;
					line-height: 1.5;
					margin-bottom: 4px;
				}

				.sub-title {
					font-size: 12px;
					color: #64748b;
					line-height: 1.4;
				}
			}
		}

		// 图片预览
		.images-preview {
			display: flex;
			gap: 8px;
			justify-content: center;
			flex-wrap: wrap;

			.image-item {
				position: relative;
				display: flex;
				flex-direction: column;
				align-items: center;

				.preview-img {
					width: 60px;
					height: 60px;
					object-fit: cover;
					border-radius: 6px;
					border: 1px solid #e5e7eb;
					transition: transform 0.2s ease;

					&:hover {
						transform: scale(1.1);
					}
				}

				.image-label {
					font-size: 10px;
					color: #6b7280;
					margin-top: 4px;
					text-align: center;
				}
			}

			.no-images {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				color: #9ca3af;
				font-size: 12px;
				padding: 20px;

				i {
					font-size: 24px;
					margin-bottom: 4px;
				}
			}
		}

		// 内容预览
		.content-preview {
			.content-text {
				font-size: 13px;
				color: #4b5563;
				line-height: 1.5;
				max-height: 60px;
				overflow: hidden;
				display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;
				text-align: left;
			}
		}

		// 操作按钮
		.action-buttons {
			display: flex;
			gap: 6px;
			justify-content: center;
			flex-wrap: wrap;

			.action-btn {
				padding: 6px 12px;
				font-size: 12px;
				border-radius: 4px;
				min-width: auto;

				&.view-btn {
					background: #6b7280;
					border-color: #6b7280;
					color: white;

					&:hover {
						background: #4b5563;
						border-color: #4b5563;
					}
				}

				&.edit-btn {
					background: #7c3aed;
					border-color: #7c3aed;

					&:hover {
						background: #6d28d9;
						border-color: #6d28d9;
					}
				}

				&.delete-btn {
					background: #ef4444;
					border-color: #ef4444;

					&:hover {
						background: #dc2626;
						border-color: #dc2626;
					}
				}
			}
		}
	}
}

// 分页区域
.pagination-section {
	display: flex;
	justify-content: center;

	.data-pagination {
		background: white;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
}

// 响应式设计
@media (max-width: 1200px) {
	.aboutus-list-container {
		padding: 20px;
	}

	.filter-section {
		.filter-content {
			.search-form {
				.filter-row {
					flex-direction: column;
					align-items: stretch;
					gap: 16px;
				}

				.filter-group {
					min-width: auto;

					.filter-input {
						.search-input {
							width: 100%;
						}
					}
				}

				.filter-actions {
					margin-left: 0;
					justify-content: center;

					.el-button {
						flex: 1;
						max-width: 120px;
					}
				}
			}
		}
	}

	.table-section {
		overflow-x: auto;

		.data-table {
			min-width: 1000px;

			.images-preview {
				.image-item {
					.preview-img {
						width: 40px;
						height: 40px;
					}

					.image-label {
						font-size: 9px;
					}
				}
			}

			.action-buttons {
				flex-direction: column;
				gap: 4px;

				.action-btn {
					width: 100%;
					max-width: 60px;
					padding: 4px 8px;
					font-size: 11px;
				}
			}
		}
	}
}

@media (max-width: 768px) {
	.aboutus-list-container {
		padding: 16px;
	}

	.page-header {
		.header-content {
			flex-direction: column;
			gap: 16px;
			text-align: center;

			.header-text {
				margin-left: 0;

				.page-title {
					font-size: 20px;
				}
			}
		}
	}

	.toolbar-section {
		.toolbar-content {
			flex-direction: column;
			gap: 12px;
			text-align: center;
		}
	}

	.table-section {
		.data-table {
			min-width: 800px;

			.images-preview {
				gap: 4px;

				.image-item {
					.preview-img {
						width: 30px;
						height: 30px;
					}
				}
			}
		}
	}
}

@media (max-width: 480px) {
	.aboutus-list-container {
		padding: 12px;
	}

	.page-header {
		.header-content {
			padding: 16px;

			.header-icon {
				width: 48px;
				height: 48px;

				.icon {
					width: 20px;
					height: 20px;
				}
			}

			.header-text {
				.page-title {
					font-size: 18px;
				}

				.page-description {
					font-size: 13px;
				}
			}

			.header-actions {
				.add-btn {
					padding: 10px 16px;
					font-size: 13px;
				}
			}
		}
	}

	.filter-section {
		.filter-card {
			:deep(.el-card__body) {
				padding: 16px;
			}
		}
	}

	.pagination-section {
		.data-pagination {
			padding: 16px;
			
			:deep(.el-pagination) {
				.el-pagination__total,
				.el-pagination__jump {
					display: none;
				}
			}
		}
	}
}
</style>
